
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// Constants
import Assets from '@/constants/assets.ts';

export interface InfoViewLiteral {
  title: string;
  subtitle: string;
}

@Component
export default class InfoView extends Vue {
  @Prop({ default: false }) private infoError!: boolean;
  @Prop({ default: false }) private squared!: boolean;
  @Prop({ default: () => ({ title: 'Title', subtitle: 'Subtitle' }) })
  private literals!: InfoViewLiteral;

  get topIcon() {
    let icon = this.squared ? Assets.IconCheckSquared : Assets.confirmationTick;
    if (this.infoError) {
      icon = this.squared ? Assets.IconCloseSquared : Assets.xIcon;
    }
    return icon;
  }

  get backgroundImage() {
    const squared_bg = {
      'background-image': `url("${Assets.acceptanceInfoBg}")`,
      'background-repeat': 'repeat-x',
      'background-size': 'contain',
      'background-position-y': 'bottom',
    };
    const normal_bg = {
      'background-image': `url("${Assets.circleBlueGreen}")`,
    };
    return this.squared ? squared_bg : normal_bg;
  }
}
